export const canReviseProduct = () => () => {
    return function (node) {
        if (! this.permission.has('revise')) {
            this.logger.error('没有权限', [node])
            return false
        }

        const {bizNodeType, pkid, stsCode} = node.data

        if (! pkid) {
            this.logger.error('只有制品才能修订', [node])
            return false
        }

        if ('RLS' !== stsCode) {
            this.logger.error('只有发布状态才能修订', [node])
            return false
        }

        const bn = this.BizNode[bizNodeType]

        if (! bn.revise) {
            const name = bn.typeName(this, node.parent)
            this.logger.error(`${name}不支持修订`, [node])
            return false
        }

        return (
            ! node.parent ||
            bn.isMounted(this, node)
        )
    }
}

export const reviseProduct = () => () => {
    return function (nodes) {
        return Promise.allSettled(
            [...nodes].map(
                async node => {
                    try {
                        const _n = this.nodeProxy(node)
                        await _n.revise()
                        this.logger.info('修订模型制品成功', [node])
                    }
                    catch (err) {
                        this.logger.error(
                            `修订模型制品失败: ${err.message}`,
                            [node]
                        )

                        err.nodes = [node]
                        throw err
                    }
                }
            )
        )
    }
}
